import { put, select } from 'redux-saga/effects';
import { getLoggedIn } from "../modules/Auth/authSelectors.js";
import appHistory from "./appHistory.ts";
import RouterPaths from "./routePaths.js";

export function* failurePut(e, action) {
    const messageCode = e.response?.data?.messageCode ?? e.message ?? 'Something went wrong';
    if (action) {
        yield put(action(messageCode));
    }

    if (e.response.status === 401) {
        const loggedIn = yield select(getLoggedIn);
        if (loggedIn) {
            appHistory.push(RouterPaths.logout);
        }
    }

    yield put(openNotify({ messageCode, type: 'FAILURE' }));
}

export const openNotify = ({ type, message }) => ({
    type: 'OPEN_NOTIFY',
    payload: { type, message },
});
